lightGallery(document.getElementById('inspiration_gallery'), {
  selector: '.lightbox',
  subHtml: '.lightbox_caption',
  download: false,
  getCaptionFromTitleOrAlt: true,
});



$(window).scroll(function(){
  if ($(window).scrollTop() >= 50) {
    $('header').addClass('header-fixed');

  } else {
    $('header').removeClass('header-fixed');
  }
});

$(document).ready(function(){

  $('#TestimonialSlider').slick({
    dots: true,
    arrows: false,
    infinite: true
  });
});



		  //Popup and Cookie Timer
		  jQuery(document).ready(function($) {
		    //check to see if the submited cookie is set, if not check if the popup has been closed, if not then display the popup
		    if (getCookie('popupCookie') != 'submited') {
		      if (getCookie('popupCookie') != 'closed') {

		        //Initiallize popup
		        $(document).ready(function() {

		          var isMobile = false; //initiate as false
		          // device detection
		          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
		            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
		            isMobile = true;
		            $(window).scroll(function() {
		              if ($(document).scrollTop() > 800) {
		                if ($('.popup-overlay').hasClass("pop_opened")) {
		                  console.log('Scrolled - popup is/was open');
		                  //do nothing
		                } else {
		                  // Show the exit popup
		                  $('.popup-overlay').css("display", "flex").hide().fadeIn();
		                  $('.popup-overlay').addClass("pop_open");
		                  $('.popup-overlay').addClass("pop_opened");
		                  console.log('Scrolled - popup NOT open');
		                }
		              }
		            });

		          } else {
		              if ($('.popup-overlay').hasClass("pop_open")) {
		                //do nothing
		              } else {
		                // Show the exit popup
		                $('.popup-overlay').css("display", "flex").hide().delay( 2800 ).fadeIn();
		                $('.popup-overlay').addClass("pop_open");
		              }
		          }
		        });
		      }
		    }
		    $('a.pop_close').click(function() {
		      $('.popup-overlay').fadeOut();
		      $('.popup-overlay').addClass("pop_opened");
		      //sets the coookie to one minute if the popup is closed (whole numbers = days)
		      setCookie('popupCookie', 'closed', 1);
		    });

		    $('.popup-overlay:not(.popup)').click(function() {
		      $('.popup-overlay').fadeOut();
		      $('.popup-overlay').addClass("pop_opened");
		      //sets the coookie to one minute if the popup is closed (whole numbers = days)
		      setCookie('popupCookie', 'closed', 1);
		    }).children().click(function(e) {
		      return false;
		    });

		    $('.popup .grimson_button').click(function() {
		      $('.popup-overlay').fadeOut();
		      $('.popup-overlay').addClass("pop_opened");
		      //sets the coookie to five minutes if the popup is submited (whole numbers = days)
		      setCookie('popupCookie', 'submited', 360);
		    });

		    function getCookie(cname) {
		      var name = cname + "=";
		      var ca = document.cookie.split(';');
		      for (var i = 0; i < ca.length; i++) {
		        var c = ca[i];
		        while (c.charAt(0) == ' ') {
		          c = c.substring(1);
		        }
		        if (c.indexOf(name) == 0) {
		          return c.substring(name.length, c.length);
		        }
		      }
		      return "";
		    }

		    function setCookie(cname, cvalue, exdays) {
		      var d = new Date();
		      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		      var expires = "expires=" + d.toUTCString();
		      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		    }

		  });
